<template>
  <section
    class="profileColumn"
    :style="cssProps"
    :class="{
      profileColumnExpanded: $store.state.display.leftColumn.profile.isExpanded,
      profileColumnCollapsed: !$store.state.display.leftColumn.profile
        .isExpanded
    }"
  >
    <div class="topBar">
      <a
        class="closeColumnBtn"
        @click="closeProfileColumn()"
      >
        <img src="@/assets/images/left-arrow.png">
      </a>
      <div class="topBarTitle">
        Profil
      </div>
    </div>

    <div class="profileContainer">
      <div class="profilePhotoDiv">
        <img
          :src="photoURL"
          class="avatarImg"
        >

        <input
          style="display: none;"
          ref="profilePhotoSelector"
          @input="imageFilesSelected"
          type="file"
          accept="image/*"
        >

        <dropdown
          :is-icon="false"
          :x="-80"
          :y="-200"
          :class-name="'photoDropDown'"
          ref="photoDropDown"
          v-if="!isLDAP"
        >
          <template slot="btn">
            <img
              src="@/assets/images/changeprofilephoto.png"
              class="photoHover"
            >
          </template>
          <template slot="body">
            <div class="photoMenuItem" @click="viewPhoto">
              Fotoğrafı görüntüle
            </div>
            <div class="photoMenuItem" @click="takePhoto">
              Fotoğraf çek
            </div>
            <div class="photoMenuItem" @click="uploadPhoto">
              Fotoğraf yükle
            </div>
            <div class="photoMenuItem" @click="removePhoto">
              Fotoğrafı kaldır
            </div>
          </template>
        </dropdown>
      </div>
      <div class="textRow">
        <div class="nameTitle">
          İSİM
        </div>
        <div class="editCont"
             :class="{error: isVisibleNameError, editable: !isLDAP}"
        >
          <div ref="visibleName"
               class="editInput"
               :contenteditable="isVisibleNameInEditMode"
               @input="visibleNameCheck"
          >
            {{ $store.state.session.user.VisibleName }}
          </div>

          <span v-if="!isLDAP">
            <img class="imgEdit" @click="makeVisibleNameEditable" src="@/assets/images/editpen.png" v-if="!isVisibleNameInEditMode">
            <img class="imgEdit" @click="submitVisibleName" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>

        <TakePhoto />
      </div>
      <div class="textRow">
        <div class="nameTitle">
          HAKKIMDA
        </div>
        <div class="editCont"
             :class="{editable: !isLDAP}"
        >
          <div ref="statusText"
               class="editInput"
               :contenteditable="isStatusTextInEditMode"
          >
            {{ $store.state.session.user.StatusText }}
          </div>
          <span v-if="!isLDAP">
            <img class="imgEdit" @click="makeStatusTextEditable" src="@/assets/images/editpen.png" v-if="!isStatusTextInEditMode">
            <img class="imgEdit" @click="submitStatusText" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>
      </div>
      <div class="textRow">
        <div class="nameTitle">
          UNVAN
        </div>
        <div class="editCont"
             :class="{editable: 1 === 2}"
        >
          <div ref="title"
               class="editInput"
               :contenteditable="isTitleInEditMode"
          >
            {{ $store.state.session.user.Title }}
          </div>
          <span v-if="1 === 2">
            <img class="imgEdit" @click="makeStatusTextEditable" src="@/assets/images/editpen.png" v-if="!isStatusTextInEditMode">
            <img class="imgEdit" @click="submitStatusText" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>
      </div>
      <div class="textRow">
        <div class="nameTitle">
          BÖLÜM
        </div>
        <div class="editCont"
             :class="{editable: 1 === 2}"
        >
          <div ref="department"
               class="editInput"
               :contenteditable="isDepartmentInEditMode"
          >
            {{ $store.state.session.user.Department }}
          </div>
          <span v-if="1 === 2">
            <img class="imgEdit" @click="makeStatusTextEditable" src="@/assets/images/editpen.png" v-if="!isStatusTextInEditMode">
            <img class="imgEdit" @click="submitStatusText" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>
      </div>
      <div class="textRow">
        <div class="nameTitle">
          EMAİL
        </div>
        <div class="editCont"
             :class="{editable: 1 === 2}"
        >
          <div ref="email"
               class="editInput"
               :contenteditable="isEmailInEditMode"
          >
            {{ $store.state.session.user.Email }}
          </div>
          <span v-if="1 === 2">
            <img class="imgEdit" @click="makeStatusTextEditable" src="@/assets/images/editpen.png" v-if="!isStatusTextInEditMode">
            <img class="imgEdit" @click="submitStatusText" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>
      </div>
      <div class="textRow">
        <div class="nameTitle">
          TELEFON
        </div>
        <div class="editCont"
             :class="{editable: 1 === 2}"
        >
          <div ref="mobile"
               class="editInput"
               :contenteditable="isMobileInEditMode"
          >
            {{ $store.state.session.user.MobilePhone }}
          </div>
          <span v-if="1 === 2">
            <img class="imgEdit" @click="makeStatusTextEditable" src="@/assets/images/editpen.png" v-if="!isStatusTextInEditMode">
            <img class="imgEdit" @click="submitStatusText" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>
      </div>
      <div class="textRow">
        <div class="nameTitle">
          DAHİLİ
        </div>
        <div class="editCont"
             :class="{editable: 1 === 2}"
        >
          <div ref="internal"
               class="editInput"
               :contenteditable="isInternalInEditMode"
          >
            {{ $store.state.session.user.InternalPhone }}
          </div>
          <span v-if="1 === 2">
            <img class="imgEdit" @click="makeStatusTextEditable" src="@/assets/images/editpen.png" v-if="!isStatusTextInEditMode">
            <img class="imgEdit" @click="submitStatusText" src="@/assets/images/oktickgray.png" v-else>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TakePhoto from './TakePhoto.vue'
import EventBus from '@/eventbus.js'
import {
  socketOutputMixin
} from '@/mixins/socketOutputMixin.js'
import {
  messageMixin
} from '@/mixins/messageMixin.js'
export default {
  components: {
    TakePhoto
  },
  mixins: [socketOutputMixin, messageMixin],
  data () {
    return {
      uploadFileObj: {},
      isVisibleNameInEditMode: false,
      isVisibleNameError: false,
      isStatusTextInEditMode: false,
      isTitleInEditMode: false,
      isDepartmentInEditMode: false,
      isEmailInEditMode: false,
      isMobileInEditMode: false,
      isInternalInEditMode: false
    }
  },
  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.sideMenu.topBarColor,
        '--fontColor': this.$config.theme.default.sideMenu.fontColor,
        '--buttonColor': this.$config.theme.default.sideMenu.buttonColor
      }
    },
    photoURL () {
      let photoURL = this.$store.state.session.user.PhotoURL
      if (photoURL === undefined) {
        return ''
      }
      if (photoURL.includes('http') || photoURL.includes('nophoto.png')) {
        return photoURL
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key.split('').reverse().join('')
        let encryptedBody = this.ewk(photoURL, key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + photoURL + '&s=' + encodeURIComponent(encryptedBody)
      }
    },
    isLDAP () {
      return this.$store.state.session.user.isLDAPUser
    }
  },
  methods: {
    closeProfileColumn () {
      this.$store.state.display.leftColumn.profile.isExpanded = false
    },

    viewPhoto () {
      this.$refs.photoDropDown.isHidden = true
      this.$store.state.display.modal.viewState = 'profilePhotoView'
      this.$modal.show('profileModal')
    },

    takePhoto () {
      this.$refs.photoDropDown.isHidden = true
      this.$modal.show('cameraModal')
      EventBus.$emit('takePhoto')
    },

    uploadPhoto () {
      this.$refs.profilePhotoSelector.click()
    },

    removePhoto () {
      this.$refs.photoDropDown.isHidden = true

      let user = this.$store.state.session.user
      user.PhotoURL = ''
      this.$store.commit('setProfilePhoto', '')
      this.updateProfile(user)
    },

    imageFilesSelected () {
      var vm = this
      vm.$refs.photoDropDown.isHidden = true

      if (this.$refs.profilePhotoSelector.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          vm.$store.state.session.user.PhotoURL = e.target.result
        }
        reader.readAsDataURL(vm.$refs.profilePhotoSelector.files[0])

        this.uploadProfileImage()
      }
    },

    uploadProfileImage () {
      this.uploadFileObj = JSON.parse(
        JSON.stringify(this.$store.state.message.uploadFileModel)
      )
      this.uploadFileObj.file = this.$refs.profilePhotoSelector.files[0]
      this.uploadFileObj.processId = this.$uuid.v4()
      this.uploadFileObj.uploadUrl = process.env.VUE_APP_UPLOADURL

      EventBus.$emit('heyManagerUploadThisFile', this.uploadFileObj, 'profileImageUploaded')
    },

    uploadManagerUploadedFile (fileObj) {
      this.$store.commit('setProfilePhoto', fileObj.resultURL)
      this.sendUpdatedProfileImage()
    },

    sendUpdatedProfileImage () {
      let user = this.$store.state.session.user
      this.updateProfile(user)
    },

    visibleNameCheck (event) {
      if (event.target.innerText.trim().length > 0) {
        this.isVisibleNameError = false
      } else {
        this.isVisibleNameError = true
      }
    },
    makeVisibleNameEditable () {
      let vn = this.$refs.visibleName
      setTimeout(function () {
        vn.focus()
      }, 0)

      this.isVisibleNameInEditMode = true
    },
    submitVisibleName () {
      if (!this.isVisibleNameError) {
        let visibleName = this.$refs.visibleName.innerText

        let user = { ...this.$store.state.session.user }
        user.VisibleName = visibleName
        user.PhotoURL = null
        this.updateProfile(user)
        this.isVisibleNameInEditMode = false

        this.$store.state.session.user.VisibleName = visibleName
      }
    },

    makeStatusTextEditable () {
      let st = this.$refs.statusText
      setTimeout(function () {
        st.focus()
      }, 0)

      this.isStatusTextInEditMode = true
    },
    submitStatusText () {
      let statusText = this.$refs.statusText.innerText

      let user = { ...this.$store.state.session.user }
      user.StatusText = statusText
      user.PhotoURL = null
      this.updateProfile(user)
      this.isStatusTextInEditMode = false
    }
  },

  created () {
    EventBus.$on(
      'profileImageUploaded',
      this.uploadManagerUploadedFile
    )
  },

  beforeDestroy () {
    EventBus.$off('profileImageUploaded')
  }
}

</script>

<style scoped>
  @error-border-color: rgb(223, 100, 100);
  @border-color: rgb(223, 223, 223);

  .topBar {
    background-color: var(--topBarColor);
    height: 80px;
    display: flex;
    align-items: flex-end;
  }

  .topBarTitle {
    color: white;
    font-size: 16px;
    font-weight: 700;
    margin: 10px;
    line-height: 40px;
  }

  .profileColumn {
    height: 100%;
    background-color: white;
    position: absolute;
    top: 0px;
    width: 100%;
    left: -100%;
    z-index: 999;
    overflow: hidden;
  }

  .profileColumnExpanded {
    left: 0px;
    transition: left 0.3s;
  }

  .profileColumnCollapsed {
    left: -100%;
    width: 100%;
    transition: left 0.3s;
  }

  .closeColumnBtn {
    cursor: pointer;
  }

  .closeColumnBtn>img {
    width: 30px;
    height: 30px;
    margin: 10px;
    margin-left: 20px;
  }

  .profileContainer {
    background-color: #eaeceb;
    width: 100%;
    height: calc(100% - 80px);
    overflow-y: scroll;
  }

  .profilePhotoDiv {
    text-align: center;
    padding-top: 50px;
    position: relative;
  }

  .avatarImg {
    margin: auto;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background-color: #fff;
    object-fit: cover;
  }

  .textRow {
    margin-top: 0px;
    background-color: white;
    padding: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .nameTitle {
    font-size: 10px;
    font-weight: 700;
    color: var(--fontColor);
    padding-bottom: 10px;
  }

  .photoHover {
    display: block;
    opacity: 0;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    top: calc(50% - 97px);
    left: calc(50% - 110px);
    background-color: RGBA(0, 0, 0, 0.8);
    position: absolute;
    cursor: pointer;
  }

  .photoHover:hover {
    display: block;
    opacity: 1;
  }

  .photoMenuItem {
    padding: 10px;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 1px;
    background-color: white;
    cursor: pointer;
  }

  .photoMenuItem:hover {
    background-color: #F0F0F0;
  }

  .editCont {
    display: flex;
    align-items: center;
    margin: 10px;
    margin-top: 0px;
    margin-bottom: 5px;
    text-align: left;
  }

  .editable {
    border-bottom: 1px solid rgb(223, 223, 223);
  }

  .error {
    border-bottom: 1px solid rgb(223, 100, 100);
  }

  .editInput {
    height: 25px;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .imgEdit {
    width: 15px;
    height: 15px;
    flex-grow: 0;
    margin-right: 10px;
    cursor: pointer;
  }

  .editInput:focus {
    outline: none;
  }
</style>

<style>
  .bp-dropdown__body {
    background-color: #d8dcdb;
    padding: 1px;
    width: 170px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

</style>
